<div class="card" style="height: 100%;">
  <div id="energy-flow-chart" class="card-body" style="padding: 0.75rem;">
    <div *ngIf="isLoading" class="loading-spinner-container" style="margin-top: 80px;">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingChartHint">
          Grafik wird generiert
        </span>
      </div>
    </div>

    <canvas id="energy-flow-chart-canvas" class="min-height w-100"
      style="display: block; box-sizing: border-box; max-height: 400px; margin: 0 auto;"></canvas>
  </div>
</div>